import { CombinedPaperTypeAndOrientation } from './types/combined-paper-type-and-orientation.type';
import { PaperDimensions } from './types/paper-dimensions.type';
import { PaperTypes } from './types/paper-types.type';

function createPaperTypes(
  paperType: PaperTypes,
  width: number,
  height: number,
): { [key: CombinedPaperTypeAndOrientation | string]: PaperDimensions } {
  return {
    [`${paperType}_PORTRAIT`]: {
      width,
      height,
    },
    [`${paperType}_LANDSCAPE`]: {
      width: height,
      height: width,
    },
  };
}

export const PAPER_TYPES: {
  [key: CombinedPaperTypeAndOrientation | string]: PaperDimensions;
} = {
  ...createPaperTypes('A0', 841, 1189),
  ...createPaperTypes('A1', 594, 841),
  ...createPaperTypes('A2', 420, 594),
  ...createPaperTypes('A3', 297, 420),
  ...createPaperTypes('A4', 210, 297),
  ...createPaperTypes('A5', 148, 210),
  ...createPaperTypes('A6', 105, 148),
  ...createPaperTypes('A7', 74, 105),
  ...createPaperTypes('A8', 52, 74),
  ...createPaperTypes('A9', 37, 52),
  ...createPaperTypes('A10', 26, 37),
};
